import type { ServerSortDefaults } from './useServerTableSort';

export const dispensarizationJournalSortMap = {
  status: 'state',
  batch: 'batch.name',
  date: 'expectedCallDateTime',
  patient: 'surname',
  clinic: 'clinic.name',
  result: 'result',
} as const;

export const surveyJournalSortMap = {
  status: 'state',
  campaign: 'batch.name',
  form: 'type',
  date: 'expectedCallDateTime',
  result: 'result',
} as const;

export const incomingJournalSortMap = {
  status: 'state',
  date: 'callDateTime',
} as const;

export const outgoingJournalSortMap = {
  status: 'state',
  notificationType: 'notificationType',
  date: 'callDateTime',
} as const;

export const usersSortMap = {
  userName: 'userName',
  role: 'Roles.First().Name',
  createDateTime: 'createDateTime',
  isLockout: 'LockoutEnd',
} as const;

export const blacklistSortMap = {
  created: 'created',
  phone: 'phone',
  comment: 'comment',
} as const;

export const dispensarizationServerSortDefaults: ServerSortDefaults = {
  SortKeySelector: 'expectedCallDateTime',
  SortOrder: 'Asc',
};

export const surveyServerSortDefaults: ServerSortDefaults = {
  SortKeySelector: 'expectedCallDateTime',
  SortOrder: 'Asc',
};

export const incomingServerSortDefaults: ServerSortDefaults = {
  SortKeySelector: 'state',
  SortOrder: 'Asc',
};

export const outgoingServerSortDefaults: ServerSortDefaults = {
  SortKeySelector: 'state',
  SortOrder: 'Asc',
};

export const usersServerSortDefaults: ServerSortDefaults = {
  SortKeySelector: 'id',
  SortOrder: 'Asc',
};

export const blacklistServerSortDefaults: ServerSortDefaults = {
  SortKeySelector: 'created',
  SortOrder: 'Desc',
};
